import type { Substitute } from '../data/ingredientSubstitutions';
import {
  SUBSTITUTE_NAMES_FR,
  SUBSTITUTE_NOTES_FR,
  SUBSTITUTE_RATIOS_FR,
} from '../data/ingredientSubstitutionsFr';

const isFrench = (language: string) => language.toLowerCase().startsWith('fr');

/** A substitute's name in the reader's language. The English name stays its key. */
export function substituteName(name: string, language: string): string {
  return isFrench(language) ? (SUBSTITUTE_NAMES_FR[name] ?? name) : name;
}

/** A substitute as the sheet prints it. Pantry matching reads the English row. */
export function substituteText(sub: Substitute, language: string): Substitute {
  if (!isFrench(language)) return sub;
  return {
    name: substituteName(sub.name, language),
    ratio: SUBSTITUTE_RATIOS_FR[sub.ratio] ?? sub.ratio,
    ...(sub.notes ? { notes: SUBSTITUTE_NOTES_FR[sub.notes] ?? sub.notes } : {}),
  };
}
